
import React, { useState, useEffect } from 'react';
import Header from '../components/shared/Header';
import Bottomber from '../components/shared/Bottomber';
// import MainLayout from '../components/layouts/MainLayout';
import { motion } from "framer-motion";
import { useNavigate } from 'react-router-dom';
import Modal from '../components/ui/Modal';
import useModal from '../hooks/useModal';
import {useFetchContent} from '../hooks/useFetchData';


const FrontPage = () => {
  const [step, setStep] = useState(0);
  const [topType, setTopType] = useState("sharehouse")
  const [query, setQuery] = useState("");
  const navigate = useNavigate();
  const [isPC, setIsPC] = useState(window.innerWidth > 768);
  const [isFirstVisitToday, setIsFirstVisitToday] = useState(false);
  const token = localStorage.getItem('token');
  const [currentPage, setCurrentPage] = useState("login");
  const { isOpen, openModal, closeModal } = useModal();
  const backUrl = process.env.REACT_APP_API_URL;
  const { data: content, loading, error } =  useFetchContent(); 

  useEffect(() => {
    const lastVisit = localStorage.getItem("lastVisitDate");
    const today = new Date().toISOString().split("T")[0];

    if (lastVisit !== today) {
      setIsFirstVisitToday(true);
      localStorage.setItem("lastVisitDate", today);
      setTimeout(() => setStep(1), 8000); // 8秒後にスクロール開始
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setStep(1), 8000);
    return () => clearTimeout(timer); // 8秒後にスクロール開始
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsPC(window.innerWidth > 768);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  if (loading) return <p>Loading...</p>;
  if (error) {
    console.error('Error fetching job post data:', error);
  }


  const sharehouse_back = isPC ? '/media/S__79011859.jpg' : '/media/S__79011855.jpg';
  const transaction_back = isPC ? '/media/S__79011862.jpg' : '/media/S__79011858.jpg';
  const job_back = isPC ? '/media/S__79011861.jpg' : '/media/S__79011857.jpg';


  const sharehouseCont = content.find(obj => obj.key === "sharehouse-cont");
  const transactionCont = content.find(obj => obj.key === "transaction-cont");
  const jobCont = content.find(obj => obj.key === "job-cont");

  // console.log(sharehouseCont)

  const topDisplayMap = {
    sharehouse:{
      title:'Share House',
      subttl:'シェアハウス掲示板',
      background: sharehouse_back,
      cont: sharehouseCont ? sharehouseCont.text : "",
      apiurl:'/sharehouse/?q=',
    },
    transaction:{
      title:'Market Place',
      subttl:'売買掲示板',
      background: transaction_back,
      cont: transactionCont ? transactionCont.text : '',
      apiurl:`${backUrl}/transaction/?q=`,
    },
    job:{
      title:'Job Offer',
      subttl:'求人掲示板',
      background: job_back,
      cont: jobCont ? jobCont.text : '',
      apiurl:`${backUrl}/job/?q=`,
    },
  };
  const topDisplay = topDisplayMap[topType]

  const handleSearch = async () => {
    if (!query) return;
    const newUrl = `${topDisplay.apiurl}${query}`
    navigate(newUrl);
  };

  const hundlepost = (topType) => {
    if(token){
      window.location.href = `/${topType}_post`
    }else{
      setCurrentPage("404-login");
      openModal();
    }
  }


  return (
    <>
    <Header />
      {isFirstVisitToday  ?(
      <motion.div
        animate={{ y: step >= 1 ? "-100vh" : "0vh" }}
        transition={{ duration: 1, ease: "easeOut" }}
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100vw",
          height: "200vh",
        }}
      >
        {/* 動画のフェードイン */}
        <motion.div
          initial={{ opacity: 1, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          style={{
            width: "100vw",
            height: "100vh",
            background: "#F8F6F1",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <video width="200px" height="auto" autoPlay muted playsInline style={{ display: "block" }}>
            <source src="/media/top.mp4" type="video/mp4" />
          </video>
        </motion.div>

        {/* スクロール後のコンテンツ */}
        <div
          className='front__wrap'
          style={{
            width: "100vw",
            height: "100vh",
            backgroundImage: `url(${topDisplay.background})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <div className='front'>
            <div className='front__serch'>
              <input
              type="text"
              placeholder="キーワードを入力"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              />
              <button onClick={handleSearch}>検索</button>
            </div>
            <div className='front__buttons'>
              <div onClick={() => setTopType("sharehouse")}><img src='/media/top-home-icon.svg'alt="" /></div>
              <div onClick={() => setTopType("transaction")}><img src='/media/top-transaction-icon.svg'alt="" /></div>
              <div onClick={() => setTopType("job")}><img src='/media/top-job-icon.svg'alt="" /></div>
            </div>
            <div className='front__cont'>
              <h4>{topDisplay.subttl}</h4>
              <h1>{topDisplay.title}</h1>
              <p>{topDisplay.cont}</p>
              <div className='front__cont-btn'>
                <button className='btn-bace' onClick={() => navigate(`/${topType}`)}>一覧を見る</button>
                <button className='btn-green' onClick={() => hundlepost(topType)}>投稿する</button>
              </div>
            </div>
            </div>
        </div>
        </motion.div>
        ):(
        <div
          className='front__wrap'
          style={{
            width: "100vw",
            height: "100vh",
            backgroundImage: `url(${topDisplay.background})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            position: "absolute",
            top: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <div className='front'>
            <div className='front__serch'>
              <input
              type="text"
              placeholder="キーワードを入力"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              />
              <button onClick={handleSearch}>検索</button>
            </div>
            <div className='front__buttons'>
              <div onClick={() => setTopType("sharehouse")}><img src='/media/top-home-icon.svg'alt="" /></div>
              <div onClick={() => setTopType("transaction")}><img src='/media/top-transaction-icon.svg'alt="" /></div>
              <div onClick={() => setTopType("job")}><img src='/media/top-job-icon.svg'alt="" /></div>
            </div>
            <div className='front__cont'>
              <h4>{topDisplay.subttl}</h4>
              <h1>{topDisplay.title}</h1>
              <p>{topDisplay.cont}</p>
              <div className='front__cont-btn'>
                <button className='btn-bace' onClick={() => navigate(`/${topType}`)}>一覧を見る</button>
                <button className='btn-green' onClick={() => hundlepost(topType)}>投稿する</button>
              </div>
            </div>
            </div>
        </div>
        )}
      <Bottomber />
    <Modal 
    isOpen={isOpen} 
    closeModal={closeModal} 
    currentPage={currentPage} 
    setCurrentPage={setCurrentPage} 
    className="login"
    >
    </Modal>
    </>
  );
};

export default FrontPage;

